<template>
  <b-modal
    v-model="show"
    header-bg-variant="primary"
    header-text-variant="light"
    title="Edit Matchfight"
    no-close-on-backdrop
    no-close-on-esc
    @close.prevent="$emit('close')"
  >
      <div class="d-flex justify-content-between">
        <div class="d-flex flex-column">
          <span>{{ fight.athleteRed.name }}</span>
          <span class="small text-muted">{{ fight.athleteRed.team }}</span>
          <span>{{ fight.athleteRed.weight }} kg</span>
        </div>
        <div class="d-flex flex-column text-right">
          <span>{{ fight.athleteBlue.name }}</span>
          <span class="small text-muted">{{ fight.athleteBlue.team }}</span>
          <span>{{ fight.athleteBlue.weight }} kg</span>
        </div>
      </div>
      <hr>
      <div>
        <label>Weight class</label>
        <b-form-select
          :options="weightClasses"
          text-field="stringDe"
          value-field="weight"
          v-model="fight.weightClass"
        />
      </div>
      <div>
        <label>Rules</label>
        <b-form-select :options="typeSelect" v-model="fight.type"/>
      </div>
      <b-row>
        <b-col>
          <label>Rounds</label>
          <b-form-select :options="roundsSelect" v-model="fight.rounds"/>
        </b-col>
        <b-col>
          <label>Duration</label>
          <b-form-select :options="durationSelect" v-model="fight.duration"/>
        </b-col>
      </b-row>
      <div>
        <label>Extra time</label>
        <div class="d-flex">
          <b-button @click="decreaseExtraTime">-</b-button>
          <input
            class="form-control"
            disabled
            :value="formattedTime(fight.extraTime)"
          />
          <b-button @click="increaseExtraTime">+</b-button>
        </div>
      </div>
    <template v-slot:modal-footer>
      <b-button variant="danger" class="mr-4" @click="discard">Delete</b-button>
      <b-button variant="primary" @click="save">Save</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'MatchFightModal',
  props: ['fight', 'show'],
  data() {
    return {
      durationSelect: [
        { value: 120, text: '2:00' },
        { value: 180, text: '3:00' },
        { value: 300, text: '5:00' },
      ],
      roundsSelect: [1, 2, 3, 4, 5],
      typeSelect: ['amateur', 'pro'],
    };
  },
  methods: {
    discard() {
      this.$store.commit('discardSetupMatchFight', this.fight);
      this.$store.commit('removeAthleteFromSetupMatchFight', this.fight.athleteRed);
      this.$store.commit('removeAthleteFromSetupMatchFight', this.fight.athleteBlue);
      this.$emit('close');
    },
    save() {
      this.$store.commit('saveSetupMatchFight', this.fight);
      this.$emit('close');
    },
    decreaseExtraTime() { this.fight.extraTime = parseInt(this.fight.extraTime, 10) - 60; },
    increaseExtraTime() { this.fight.extraTime = parseInt(this.fight.extraTime, 10) + 60; },
    formattedTime(value) {
      const minutes = Math.floor(value / 60);
      const seconds = value % 60;
      return `${minutes}:${String(seconds).padStart(2, '0')}`;
    },
  },
  computed: {
    athletes() {
      return this.$store.state.setup.matchFights.athletes;
    },
    weightClasses() {
      return this.$weightClasses();
    },
  },
};
</script>

<style scoped>

</style>
